<template>
    <van-tabs type="card" color="#07C160" sticky :offset-top="100">
        <van-tab style="margin-top: 10px" title="初审意见">
        <template>
            <div>

                <van-cell-group>
                  <van-cell title="填表人" :value="infos.firstRiskPerson || '未填写'"></van-cell>
                </van-cell-group>
                <van-divider>业务概要</van-divider>
                <van-cell-group>
                  <van-cell title="当前抵押权人" :value="infos.currentMortgagePerson || '未填写'"></van-cell>
                  <van-cell title="当前对应负债"/>
                  <van-cell :value="infos.currentMortgageAmount || '未填写'"></van-cell>
                  <van-cell title="是否需要结清" :value="infos.settlementIsRequired || '未填写'"></van-cell>
                  <van-cell title="是否关联大橙垫资" :value="infos.associatedAdvances || '未填写'"></van-cell>
                  <van-cell title="借款用途"/>
                  <van-cell :value="infos.purposeOfBorrowing || '未填写'"></van-cell>
                  <van-cell title="借款原因"/>
                  <van-cell :value="infos.reasonOfBorrowing || '未填写'"></van-cell>
                  <van-cell title="还款来源"/>
                  <van-cell :value="infos.realRepaySource || '未填写'"></van-cell>
                  <van-cell title="情况说明" />
                  <van-cell :value="infos.businessSummaryFactSheet || '未填写'"></van-cell>
                </van-cell-group>

                <van-divider>批贷信息</van-divider>
                <van-cell-group>
                  <van-cell title="批贷金额" :value="infos['approveAmt'] ? (infos['approveAmt'] / 10000) +'万元' : applyInfo['approveAmt']"></van-cell>
                  <van-cell title="收费标准" :value="infos['approveRate'] ? infos['approveRate'] +'%' : applyInfo['approveRate'] + '%'"></van-cell>
                  <van-cell title="贷款期限" :value="infos['approveNo'] ? infos['approveNo'] +'个月' : applyInfo['approveNo']"></van-cell>
                  <van-cell title="是否公证" :value="infos['notarization'] ? infos['notarization'] : '-'"></van-cell>
                  <van-cell title="抵押顺位" :value="infos['mortgagePriority'] ? infos['mortgagePriority'] : '未填写'"></van-cell>
                </van-cell-group>

                <van-divider>借款人资料</van-divider>
                <van-cell-group>
                    <van-cell title="职业是否为特殊行业" :value="infos.industry" />
                    <van-cell title="是否为外籍或港澳台居民" :value="infos.domicile" />

                    <van-cell title="其他应关注信息" />
                    <van-cell :value="infos.customerOther" />
                </van-cell-group>

                <van-divider>婚姻状况</van-divider>
                <van-cell-group>
                    <van-cell title="当前婚姻状况" :value="infos.marriage" />
                    <van-cell title="存在离婚补偿义务" />
                    <van-cell :value="infos.compensate" />

                    <van-cell title="是否有子女" />
                    <van-cell :value="infos.children" />

                    <van-cell title="其他应关注信息" />
                    <van-cell :value="infos.marriageOther" />
                </van-cell-group>

                <div v-for="(item, index) in house" :key="index">
                  <van-divider>房产资料 {{ house.length > 1 ? `(${index + 1})` : ''}}</van-divider>
                    <van-cell-group>
                        <van-cell
                                title="房产地址"
                                :value="`${item.province} ${item.city} ${item.district} ${item.detailedAdress}`"
                        />
                        <van-cell title="小区名称" :value="item.estateName" />
                        <van-cell title="房屋面积" :value="`${item.houseArea} ㎡`" />
                        <van-cell title="房屋楼层" :value="item.floor" />
                        <van-cell title="房龄" :value="item.hourseAge | filterHouseAgeText" />
                        <van-cell title="取得时间" :value="item.purchaseDate | day" />
                        <van-cell title="产权归属" :value="infos[`house_${item.customerHouseId}_propertyDesc`]" />
                        <van-cell title="房产来源" :value="infos[`house_${item.customerHouseId}_source`]" />
                        <van-cell title="房产性质" :value="item.propertyType | filterHouseTypeText" />

<!--                        <van-cell-->
<!--                                title="担保责任金额"-->
<!--                                :value="infos[`house_${item.customerHouseId}_loan_guarantee`]"-->
<!--                        />-->
                        <van-cell title="是否出租" :value="item.lease | filterLeaseTypeText" />
<!--                        <van-cell title="是否出租【合同打印取值】" :value="infos[`house_${item.customerHouseId}_isLease`] | filterLeaseTypeText" />-->
                        <van-cell v-if="item.lease === 'yes'" title="出租情况说明" :value="infos[`house_${item.customerHouseId}_lease`]" />
                        <van-cell title="是否有老人或小孩居住" :value="infos[`house_${item.customerHouseId}_live`]" />
                        <van-cell title="装修状态" :value="item.decorate | filterHouseDecorateText" />

                        <van-cell title="下户意见说明" />
                        <van-cell :value="infos[`house_${item.customerHouseId}_survey`]" />

                        <van-cell title="在京有无其他不动产信息" />
                        <van-cell :value="infos[`house_${item.customerHouseId}_only`]" />

                        <van-cell title="其他应关注信息" />
                        <van-cell :value="infos[`house_${item.customerHouseId}_other`]" />
                    </van-cell-group>
                </div>

                <van-divider>估值数据(所有抵押物汇总计算)</van-divider>
                <van-cell-group>
                    <van-cell title="世联评估值" :value="computeShowEstimatePrice(infos.estimatePriceBySL)" />
                    <van-cell title="房估估评估值" :value="computeShowEstimatePrice(infos.estimatePriceByFgg)" />
                    <van-cell title="快出价" :value="computeShowEstimatePrice(infos.estimatePriceByFast)" />
                    <van-cell title="评估平均数" :value="computeShowEstimatePrice(infos.estimatePriceAverage)" />
                    <van-cell title="综合评估价(信托)" :value="computeShowComprehensiveAssessmentPrice(infos.finalPrice)" />
                    <van-cell title="一押余额" :value="`${(infos.bankLoanBalance || 0) / 10000} 万`" />
                    <van-cell title="真实抵押率" :value="`${computeRealMortgageRate(infos, applyInfo)}%`" />
                    <van-cell title="放款上限" :value="`${computeMaxLoanAmount(infos)} 万`" />
<!--                    <van-cell title="贷款对应房产估值" :value="`${applyInfo.estimatePrice} 万元`" />-->
                </van-cell-group>

                <van-divider>征信报告</van-divider>
                <van-cell-group>
                    <van-cell title="橙易贷金额" :value="`${applyInfo.approveAmt / 10000} 万元`" />
                    <van-cell title="信贷余额" :value="`${infos.creditAmount / 10000} 万元`" />
                    <van-cell title="信用卡余额" :value="`${infos.creditCardAmount / 10000} 万元`" />
                    <van-cell title="在京备房抵押贷款余额" :value="`${infos.bankBalanceInBj / 10000} 万元`" />
                    <van-cell title="一抵贷款余额" :value="`${(infos.bankLoanBalance || 0) / 10000} 万元`" />
                    <van-cell title="其他负债" :value="`${infos.otherAmount / 10000} 万元`" />
                    <van-cell title="在京备房评估值" :value="`${infos.estimateOther / 10000} 万元`" />
                    <van-cell title="资产负债率" :value="`${calDebt(infos, applyInfo)}%`" />

                    <van-cell title="客户及共借人是否有当前逾期的情形" />
                    <van-cell :value="infos.overdue" />

                    <van-cell title="客户及共借人近一年内是否有超出连3的情况" />
                    <van-cell :value="infos.moreThan3"  class="custom-cell"/>

                    <van-cell title="是否有呆账、冻结、关注、次级、可疑、代偿等信息" :value="infos.abnormal" />

                    <van-cell title="估值数据差异是否超过10%？如超过10%，请解释原因，并根据预计还款来源对综合估值结果进行合理调整"/>
                    <van-cell :value="infos.reasonsForValuationDataDeviationsText"/>

                    <van-cell title="其他应关注信息" />
                    <van-cell :value="infos.creditOther" />
                </van-cell-group>

                <van-divider>司法查询</van-divider>
                <van-cell-group>
                    <van-cell title="客户及共借人是否有涉及借贷纠纷被告"/>
                    <van-cell :value="infos.defendant" />

                    <van-cell title="客户及共借人是否有涉及借贷纠纷原告"/>
                    <van-cell :value="infos.plaintiff" />

                    <van-cell title="客户及共借人当前是否有涉诉或被执行信息（非借贷纠纷）" />
                    <van-cell :value="infos.execute" />

                    <van-cell title="客户经营主体及关联公司是否有经济纠纷" />
                    <van-cell :value="infos.economy" />

                    <van-cell title="其他应关注信息" />
                    <van-cell :value="infos.judicialOther" />
                </van-cell-group>

                <van-divider>提还违约金</van-divider>
                <van-cell-group>
                    <van-cell title="期限" :value="`${infos.prepay_rule1_month}个月内(含)提前还款，收取提前还款金额的${infos.prepay_rule1_ratio}%作为提前还款违约金`" />
                    <van-cell title="期限" :value="`${infos.prepay_rule2_month}个月内(含)提前还款，收取提前还款金额的${infos.prepay_rule2_ratio}%作为提前还款违约金`" />
                    <van-cell title="期限" :value="`${infos.prepay_rule3_month}个月内(含)提前还款，收取提前还款金额的${infos.prepay_rule3_ratio}%作为提前还款违约金`" />
                    <van-cell title="期限" :value="`${infos.prepay_rule4_month}个月内(含)提前还款，收取提前还款金额的${infos.prepay_rule4_ratio}%作为提前还款违约金`" />
                    <van-cell title="超过期限" :value="`${infos.prepay_rule5_month}个月提前还款，无需支付提前还款违约金`" />
                    <van-cell title="贷款合同是否申请强执公证" :value="infos.notarization" />
                </van-cell-group>

                <van-divider>审批意见</van-divider>
                <van-cell-group>
                    <van-cell title="风控内勤审核意见；是否需要客户补充其他资料"/>
                    <van-cell :value="infos.riskAudit" />

                    <van-cell title="审核人的审批意见；是否为附条件审批"/>
                    <van-cell :value="infos.audit" />

                    <van-cell title="橙易贷专员的审批意见" />
                    <van-cell :value="infos.assistantAudit" />

                    <van-cell title="运营后续跟进是否有应注意事项" />
                    <van-cell :value="infos.operateAudit" />
                </van-cell-group>
            </div>
        </template>
        </van-tab>

        <van-tab style="margin-top: 10px" title="初审附件">
            <oss-upload :applyId="applyInfo.applyId" :groupCode="70" refName="zsfj" ></oss-upload>
            <oss-upload :applyId="applyInfo.applyId" :groupCode="501" refName="fkpgyj" ></oss-upload>
        </van-tab>
    </van-tabs>
</template>

<script>
    import { endCreditView } from '@/api/loanInfo'
    import {getApplyInfoHouses} from "../../../../../api/loanInfo";
    import ossUpload from '@/views/component/oss-upload'

    export default {
        name: 'risk-final-view',
        props: {
            applyInfo: {
                type: Object,
                default: null
            }
        },
        data () {
            return {
                infos: {},
                house:[]
            }
        },
        components: {
            ossUpload
        },
        mounted () {
            this.loadData()
            this.loadHouses()
        },
        methods: {
            loadData() {
                let params = {
                    applyId: this.applyInfo.applyId
                }
                endCreditView(params).then(res => {
                    this.infos = res.infos
                })
            },
            loadHouses() {
                getApplyInfoHouses({applyId: this.applyInfo.applyId}).then(res => {
                    if (res.success) {
                        this.house = res.data
                    }
                })
            },
          computeShowEstimatePrice (value) {
            const customMortgageRate = this.infos.customMortgageRate || 75
            return value + '万（*' + customMortgageRate + '%=' + parseFloat(value * customMortgageRate * 0.01).toFixed(2) + '万）'
          },
          computeShowComprehensiveAssessmentPrice(value) {
            return value + '万（*' + this.infos.mortgageRateContract + '%=' + parseFloat(value * this.infos.mortgageRateContract * 0.01).toFixed(2) + '万）'
          },
          computeRealMortgageRate (infos, applyInfo) {
            return ((parseFloat(infos.bankLoanBalance || 0) + parseFloat(applyInfo.approveAmt)) / (infos.estimatePriceAverage * 10000) * 100).toFixed(2)
          },
          computeMaxLoanAmount (infos) {
            const customMortgageRate = this.infos.customMortgageRate || 75
            return (parseFloat(Math.min(infos.estimatePriceAverage * 100 * customMortgageRate - (infos.bankLoanBalance || 0), 20000000)) / 10000 - 0.5).toFixed(0)
          },
          calDebt (infos, applyInfo) {
            return ((applyInfo.approveAmt +
                    parseFloat(infos['creditAmount'] || 0) +
                    parseFloat(infos['bankLoanBalance'] || 0) +
                    parseFloat(infos['creditCardAmount'] || 0) +
                    parseFloat(infos['bankBalanceInBj'] || 0) +
                    parseFloat(infos['bankLoanBalance'] || 0) +
                    parseFloat(infos['otherAmount'] || 0)) /
                (parseFloat(infos['estimatePriceAverage'] || 0) * 10000 + parseFloat(infos['estimateOther'] || 0)) * 100).toFixed(2)
          }

        }
    }
</script>

<style scoped>
    table {
        overflow: hidden;
        border: 1px solid #d3d3d3;
        background: #fefefe;
        width: 96%;
        -moz-border-radius: 5px; /* FF1+ */
        -webkit-border-radius: 5px; /* Saf3-4 */
        border-radius: 5px;
        -moz-box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
        -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
        font-size: 14px;
        /*font-weight: bold;*/
    }

    th, td {
        padding: 18px 28px 18px;
        text-align: center;
        vertical-align: middle;
    }

    th {
        padding-top: 22px;
        text-shadow: 1px 1px 1px #fff;
        background: #e8eaeb;
    }

    td {
        border-top: 1px solid #e8e8e8;
        border-right: 1px solid #e8e8e8;
    }

    tr.odd-row td {
        background: #f6f6f6;
    }

    /*td.first, th.first {
        text-align: left
    }*/

    tr th {
        text-align: left;
    }

    td.last {
        border-right: none;
    }

    td {
        background: -moz-linear-gradient(100% 25% 90deg, #fefefe, #f9f9f9);
        background: -webkit-gradient(linear, 0% 0%, 0% 25%, from(#f9f9f9), to(#fefefe));
    }

    tr.odd-row td {
        background: -moz-linear-gradient(100% 25% 90deg, #f6f6f6, #f1f1f1);
        background: -webkit-gradient(linear, 0% 0%, 0% 25%, from(#f1f1f1), to(#f6f6f6));
    }

    th {
        background: -moz-linear-gradient(100% 20% 90deg, #e8eaeb, #ededed);
        background: -webkit-gradient(linear, 0% 0%, 0% 20%, from(#ededed), to(#e8eaeb));
    }

    tr:first-child th.first {
        -moz-border-radius-topleft: 5px;
        -webkit-border-top-left-radius: 5px; /* Saf3-4 */
    }

    tr:first-child th.last {
        -moz-border-radius-topright: 5px;
        -webkit-border-top-right-radius: 5px; /* Saf3-4 */
    }

    tr:last-child td.first {
        -moz-border-radius-bottomleft: 5px;
        -webkit-border-bottom-left-radius: 5px; /* Saf3-4 */
    }

    tr:last-child td.last {
        -moz-border-radius-bottomright: 5px;
        -webkit-border-bottom-right-radius: 5px; /* Saf3-4 */
    }

    .van-cell {
      white-space: pre-wrap !important;
    }

    .van-cell__value--alone {
       color: #969799 !important;
    }


</style>
